import React from "react";

const UnderlinedLink = () => {
  return (
    <svg
      viewBox="0 0 800 600"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="linearGradient-1"
        >
          <stop stopColor="#7BCFF4" offset="0%" />
          <stop stopColor="#45A2E5" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="linearGradient-2"
        >
          <stop stopColor="#FDB9A1" offset="0%" />
          <stop stopColor="#FA8368" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="linearGradient-5"
        >
          <stop stopColor="#5F5F5F" offset="0%" />
          <stop stopColor="#000000" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="linearGradient-8"
        >
          <stop stopColor="#FFE75E" offset="0%" />
          <stop stopColor="#FFCB30" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="linearGradient-9"
        >
          <stop stopColor="#BAF8E9" offset="0%" />
          <stop stopColor="#84EFCF" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="linearGradient-14"
        >
          <stop stopColor="#F0F0F0" offset="0%" />
          <stop stopColor="#DCDCDC" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="linearGradient-17"
        >
          <stop stopColor="#F8F8F8" offset="0%" />
          <stop stopColor="#EEEEEE" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="90.711689%"
          y1="19.3635644%"
          x2="50%"
          y2="100%"
          id="linearGradient-22"
        >
          <stop stopColor="#F0F0F0" offset="0%" />
          <stop stopColor="#DCDCDC" offset="100%" />
        </linearGradient>
        <path
          id="floater-11"
          d="M460.675043,418.023513 L507.362096,443.659035 C509.281433,444.712929 510.474247,446.728699 510.474247,448.918344 L510.474247,499.677601 C510.474247,501.867247 509.281433,503.883016 507.362096,504.93691 L460.675043,530.572432 C458.876462,531.56002 456.697928,531.56002 454.899346,530.572432 L408.212294,504.93691 C406.292957,503.883016 405.100142,501.867247 405.100142,499.677601 L405.100142,448.918344 C405.100142,446.728699 406.292957,444.712929 408.212294,443.659035 L454.899346,418.023513 C456.697928,417.035925 458.876462,417.035925 460.675043,418.023513 Z"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin="5s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 457.787185 474.297958; 360 457.787185 474.297958"
            keyTimes="0; 1"
            begin="5s"
          />
        </path>
        <circle id="floater-12" cx="612" cy="131" r="71">
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin="5.5s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 612 131; 360 612 131"
            keyTimes="0; 1"
            begin="5.5s"
          />
        </circle>
        <circle id="floater-13" cx="395" cy="315" r="82">
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin="6s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 395 315; 360 395 315"
            keyTimes="0; 1"
            begin="6s"
          />
        </circle>
        <circle id="floater-6" cx="540.5" cy="417.5" r="27.5">
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin="2.5s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 540.5 417.5; 360 540.5 417.5"
            keyTimes="0; 1"
            begin="2.5s"
          />
        </circle>
        <circle id="floater-7" cx="245.5" cy="389.5" r="31.5">
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin="3s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 245.5 389.5; 360 245.5 389.5"
            keyTimes="0; 1"
            begin="3s"
          />
        </circle>
        <circle id="floater-9" cx="283" cy="164" r="54">
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin="4s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 283 164; 360 283 164"
            keyTimes="0; 1"
            begin="4s"
          />
        </circle>
        <rect
          id="floater-2"
          x="304.712813"
          y="442.712813"
          width="64"
          height="64"
          rx="10"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin=".5s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 336.712813 474.712813; 360 336.712813 474.712813"
            keyTimes="0; 1"
            begin=".5s"
          />
        </rect>
        <rect
          id="floater-3"
          x="535.608639"
          y="251.608639"
          width="85.2871871"
          height="85.2871871"
          rx="10"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin="1s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 578.252232 294.252232; 360 578.252232 294.252232"
            keyTimes="0; 1"
            begin="1s"
          />
        </rect>
      </defs>
      <g id="Team" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect
          id="floater-1"
          fill="url(#linearGradient-1)"
          x="129.712813"
          y="265.948915"
          width="64"
          height="64"
          rx="10"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 161.712813 297.948915; 360 161.712813 297.948915"
            keyTimes="0; 1"
          />
        </rect>

        <use id="Mask" fill="url(#linearGradient-2)" xlinkHref="#floater-2" />

        <use id="Mask" fill="url(#linearGradient-5)" xlinkHref="#floater-3" />

        <circle
          id="floater-4"
          fill="url(#linearGradient-8)"
          cx="501"
          cy="204"
          r="40"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin="1.5s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 501 204; 360 501 204"
            keyTimes="0; 1"
            begin="1.5s"
          />
        </circle>

        <path
          id="floater-5"
          d="M427.474658,114.428108 C405.383268,114.428108 387.474658,132.336718 387.474658,154.428108 C387.474658,176.519498 405.383268,194.428108 427.474658,194.428108 L427.474658,114.428108 Z"
          fill="url(#linearGradient-9)"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin="2s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 407.474670 154.428104; 360 407.474670 154.428104"
            keyTimes="0; 1"
            begin="2s"
          />
        </path>

        <use id="Mask" fill="url(#linearGradient-9)" xlinkHref="#floater-6" />

        <use id="Mask" fill="url(#linearGradient-9)" xlinkHref="#floater-7" />

        <circle
          id="floater-8"
          fill="url(#linearGradient-14)"
          cx="337"
          cy="79"
          r="19"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin="3.5s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 337 79; 360 356 98"
            keyTimes="0; 1"
            begin="3.5s"
          />
        </circle>

        <use id="Mask" fill="#45A2E5" xlinkHref="#floater-9" />

        <path
          d="M279.564687,234.585697 L303.914893,247.956218 C305.83423,249.010112 307.027044,251.025881 307.027044,253.215527 L307.027044,279.444783 C307.027044,281.634429 305.83423,283.650198 303.914893,284.704092 L279.564687,298.074613 C277.766106,299.062201 275.587571,299.062201 273.78899,298.074613 L249.438784,284.704092 C247.519448,283.650198 246.326633,281.634429 246.326633,279.444783 L246.326633,253.215527 C246.326633,251.025881 247.519448,249.010112 249.438784,247.956218 L273.78899,234.585697 C275.587571,233.598109 277.766106,233.598109 279.564687,234.585697 Z"
          id="floater-10"
          fill="url(#linearGradient-8)"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            repeatCount="indefinite"
            dur="8s"
            calcMode="spline"
            values="0 0; 0 20; 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1;"
            begin="4.5s"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="60s"
            additive="sum"
            values="0 278.811782 264.195205; 360 278.811782 264.195205"
            keyTimes="0; 1"
            begin="4.5s"
          />
        </path>

        <use id="Mask" fill="url(#linearGradient-17)" xlinkHref="#floater-11" />

        <use id="Mask" fill="url(#linearGradient-2)" xlinkHref="#floater-12" />

        <use id="Mask" fill="url(#linearGradient-22)" xlinkHref="#floater-13" />
      </g>
    </svg>
  );
};

export default UnderlinedLink;



// WEBPACK FOOTER //
// ./src/components/FloatingTeamSvg/index.js